import { render, staticRenderFns } from "./MetalPricing.vue?vue&type=template&id=81a3aec4&"
import script from "./MetalPricing.vue?vue&type=script&lang=js&"
export * from "./MetalPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports